export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3200/api';

export const AUTH_ENDPOINTS = {
  SIGNIN: '/auth/signin',
} as const;

export const USER_ENDPOINTS = {
  GET_USER_DETAILS: '/user/getUserDetails',
  UPDATE_USER: '/user/update',
} as const;

export const STORE_ENDPOINTS = {
  MY_STORES: '/stores/my-stores',
  ALL_STORES: '/stores/all',
  PENDING_REQUESTS: '/stores/pending-requests',
  CREATE: '/store/create',
  UPDATE: (storeId: number) => `/store/settings/${storeId}`,
  ACCEPT: (storeId: number) => `/store/accept/${storeId}`,
  REJECT: (storeId: number) => `/store/reject/${storeId}`,
  DELETE: (storeId: number) => `/store/${storeId}`,
  GET_STORE_PRODUCTS: (storeId: number) => `/store/${storeId}/sectorsProducts`,
} as const;

export const PRODUCT_ENDPOINTS = {
  ALL: '/product/all',
  CREATE: '/product/create',
  UPDATE: '/product/update',
  DELETE: (productId: number) => `/products/${productId}`,
} as const;

export const LOCATION_ENDPOINTS = {
  ALL_LOCATIONS: '/location/all-locations',
  SUBLOCATIONS: (locationId: number) => `/location/${locationId}/sublocations`,
  CREATE: '/location/create',
  UPDATE: '/location/update',
  DELETE: (locationId: number) => `/location/${locationId}`,
} as const;

export const SUBLOCATION_ENDPOINTS = {
  CREATE: '/sublocation/create',
  UPDATE: '/sublocation/update',
  DELETE: (subLocationId: number) => `/sublocation/${subLocationId}`,
} as const;

export const CATEGORY_ENDPOINTS = {
  GET_ALL: '/category/getAllCategories',
  STORES_BY_CATEGORY: (categoryId: number) => `/category/${categoryId}/stores`,
  CREATE: '/category/create',
  UPDATE: '/category/update',
  DELETE: (categoryId: number) => `/categories/${categoryId}`,
} as const;

export const SECTOR_ENDPOINTS = {
  ALL: '/sector/all',
  ALL_WITH_STORES: '/sector/all-with-stores',
  BY_STORE: (storeId: number) => `/sector/store/${storeId}`,
  CREATE: '/sector/create',
  UPDATE: '/sector/update',
  DELETE: (sectorId: number) => `/sectors/${sectorId}`,
} as const;

export const ADVERTISEMENT_ENDPOINTS = {
  GET_ALL: '/advertisement',
  GET: (id: number) => `/advertisement/${id}`,
  CREATE: '/advertisement',
  UPDATE: (id: number) => `/advertisement/${id}`,
  DELETE: (id: number) => `/advertisement/${id}`,
} as const;

export const DASHBOARD_ENDPOINTS = {
  STATS: '/dashboard/stats',
} as const;

export const ROLE_ENDPOINTS = {
  ALL: '/role/all',
} as const;

export const USER_MANAGEMENT_ENDPOINTS = {
  ALL: '/users/all',
  CREATE: '/users/create',
  UPDATE: (userId: number) => `/users/${userId}`,
  DELETE: (userId: number) => `/users/${userId}`,
} as const;